
export default {
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
};
